export const URL_REDIRECT = {
  categorie: "/categories/",
};
